export default "__VITE_ASSET__3af06578__"